import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { InvestmentStrategyStore } from '@zero/onboarding/domain';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { IconComponent } from '@zero/shared/ui-web-design-system';
import { WatchlistFacade } from '@zero/shared/util-global-state';
import {
  commonRoutes,
  URL_APPSTORE_APPLE,
  URL_APPSTORE_APPLE_TAN,
  URL_APPSTORE_GOOGLE,
  URL_APPSTORE_GOOGLE_TAN,
} from 'constants/web-app-constants';

@Component({
  selector: 'guided-tour-teaser',
  imports: [TranslocoPipe, IconComponent, NgTemplateOutlet, RouterLink, AsyncPipe],
  templateUrl: './guided-tour-teaser.component.html',
  styleUrl: './guided-tour-teaser.component.scss',
  providers: [InvestmentStrategyStore],
})
export class GuidedTourTeaserComponent implements OnInit {
  public readonly savingsPlanFacade = inject(SavingsPlanFacade);
  public readonly watchlistFacade = inject(WatchlistFacade);
  public readonly investmentStrategyStore = inject(InvestmentStrategyStore);

  public readonly ZERO_APP_APPLE_URL = URL_APPSTORE_APPLE;
  public readonly ZERO_APP_GOOGLE_URL = URL_APPSTORE_GOOGLE;
  public readonly ZERO_TAN_APP_APPLE_URL = URL_APPSTORE_APPLE_TAN;
  public readonly ZERO_TAN_APP_GOOGLE_URL = URL_APPSTORE_GOOGLE_TAN;
  public readonly WATCHLIST_URL = commonRoutes.postlogin.watchlist;
  public readonly ONBOARDING_SAVINGS_PLAN_JOURNEY_URL = commonRoutes.postlogin.onboarding.savingsPlan.favoriteSuggestions;
  public readonly SAVINGS_PLANS_URL = commonRoutes.prelogin.preview + commonRoutes.postlogin.savings_plans;
  public readonly INVESTMENT_STRATEGY_URL = commonRoutes.postlogin.onboarding.investmentStrategy.choice;

  async ngOnInit() {
    this.savingsPlanFacade.loadOnboardingSavingsPlans();
    await this.investmentStrategyStore.loadStrategies();
    this.investmentStrategyStore.loadNotedStrategy();
  }
}
